import {
  DOCS_DOMAIN_MAP,
  FORMSTACK_DOCS_MANAGE_DOCUMENTS_URL,
  FORMS_DOMAIN_MAP,
  FSID_DOMAIN_MAP,
  Products,
  SIGN_DOMAIN_MAP,
} from '@/common/constants';
import { BUILD_ENVIRONMENT_NAMES } from '@/env-config';

const getProductDomain = (product: Products) => {
  const buildEnv = process.env.COPILOT_BUILD_ENV || BUILD_ENVIRONMENT_NAMES.PRODUCTION;
  switch (product) {
    case Products.Sign:
      return SIGN_DOMAIN_MAP[buildEnv];
    case Products.Documents:
      return DOCS_DOMAIN_MAP[buildEnv];
    case Products.FormstackClassic:
      return FORMS_DOMAIN_MAP[buildEnv];
    case Products.FSID:
    default:
      return FSID_DOMAIN_MAP[buildEnv];
  }
};

export const buildProductUrl = (product: Products, route = '') => {
  const baseUrl = getProductDomain(product);
  return `${baseUrl}/${route}`;
};

export const buildDocsEditUrl = (documentId: string) =>
  `${FORMSTACK_DOCS_MANAGE_DOCUMENTS_URL}?page=overview&document_id=${documentId}`;

export const buildDocsEditDeliveryUrl = (documentId: string) =>
  `${FORMSTACK_DOCS_MANAGE_DOCUMENTS_URL}?page=edit&step=notifications&document_id=${documentId}`;
